import { render, staticRenderFns } from "./ClearDb.vue?vue&type=template&id=4baba699&scoped=true&"
import script from "./ClearDb.vue?vue&type=script&lang=js&"
export * from "./ClearDb.vue?vue&type=script&lang=js&"
import style0 from "./ClearDb.vue?vue&type=style&index=0&id=4baba699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baba699",
  null
  
)

component.options.__file = "ClearDb.vue"
export default component.exports